import { put, takeLatest } from 'redux-saga/effects';
import { AppApiInstance } from '../../api/app-api';
import { types } from './appparams.type';
import { store } from './../configStore';
import { ERROR_MESSAGES } from "../../utils/const";
import ZaloPaySDK from "../../utils/zalopay";

function* getTokenUser({ cb }) {
  const { userInfo } = store.getState().appParams;
  try {
    const data = yield AppApiInstance.verifyUser({ muid: userInfo.mUid, maccesstoken: userInfo.mAccessToken });
    if (data && data.returncode === 1) {
      yield put({ type: types.GET_TOKEN_SUCCESS, token: 'token' });
      cb(true);
    } else {
      ZaloPaySDK.showDialog({ message: ERROR_MESSAGES.LOGIN_FAIL, buttons: [{ text: 'Đóng' }] });
      cb(false);
    }
  } catch (err) {
    ZaloPaySDK.showDialog({ message: ERROR_MESSAGES.LOGIN_FAIL, buttons: [{ text: 'Đóng' }] });
    cb(false);
  }
}

function* getOauthV1Code({ cb }) {
  const { userInfo } = store.getState().appParams;
  try {
    // const data = yield AppApiInstance.getUserInfo({
    //   oauthCode: "La1YVVIkQX2cRowkkAuA063KSVKLEDcFd9m6XAcope2Yf0To3wU6mptfy4nXm5gx",
    //   verifierCode: "so.P4bV-up--tIAigFyHrIMa0QkslwC7P5ctZ_1B6_5"
    // }) // test local
    const data = yield AppApiInstance.getUserInfo({ oauthCode: userInfo.oauthCode, verifierCode: userInfo.verifierCode });
    const userData = data?.data?.getUserInfo?.data || {};
    yield put({
      type: types.UPDATE_USER_INFO, userInfo: {
        muid: userData.muid,
        user_name: userData.user_name || userData.user_identity_info?.full_name || "",
        user_phone: userData.user_phone ? (userData.user_phone + "").replace(/^84/, "0") : "",
        user_email: userData.user_email || "",
        id_number: userData.user_identity_image?.id_number || "",
        permanent_address: userData.user_identity_info?.permanent_address || "",
      }
    });
    cb(true);
  } catch (error) {
    ZaloPaySDK.showDialog({ message: ERROR_MESSAGES._LOGIN_FAIL, buttons: [{ text: 'Đóng' }] });
    cb(false);
  }
}

export function* appParamsWatcher() {
  yield takeLatest(types.GETTING_TOKEN, getTokenUser);
  yield takeLatest(types.GET_OAUTH_CODE, getOauthV1Code);
}